/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.347 4.793a1.677 1.677 0 00-1.175-1.182C12.141 3.332 8 3.332 8 3.332s-4.14 0-5.18.279a1.664 1.664 0 00-1.174 1.182C1.375 5.832 1.375 8 1.375 8s0 2.168.279 3.207c.15.572.602 1.024 1.174 1.182 1.031.279 5.172.279 5.172.279s4.14 0 5.18-.279a1.664 1.664 0 001.174-1.182c.271-1.039.271-3.207.271-3.207s0-2.168-.278-3.207zm-7.702 5.18V6.027L10.108 8 6.645 9.972z"
}));

export default SvgYoutube;